import React, { useEffect, useState } from "react";
import holidayService from "../../services/holidayService";

const HolidayEditModal = ({ holiday, onClose, onSaved }) => {
  const [formData, setFormData] = useState({
    name: "",
    date: "",
    duration_days: 1,
    holiday_type: "NATIONAL",
    payment_status: "PAID",
    is_active: true,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ============================================================
  // CHARGER LE JOUR FÉRIÉ
  // ============================================================
  useEffect(() => {
    if (!holiday) {
      return;
    }

    console.log(
      "[HolidayEditModal] Jour férié reçu :",
      holiday
    );

    const date =
      holiday.date ||
      holiday.start ||
      "";

    const name =
      holiday.name ||
      holiday.title ||
      "";

    const duration =
      Number(
        holiday.duration_days ??
        holiday.details?.duration_days ??
        1
      ) || 1;

    let holidayType =
      holiday.holiday_type ||
      holiday.details?.holiday_type ||
      "NATIONAL";

    /*
     * Normalisation des anciennes valeurs éventuelles
     */
    const normalizedType = String(
      holidayType
    )
      .trim()
      .toUpperCase();

    if (
      normalizedType === "RELIGIEUX" ||
      normalizedType === "RELIGIOUS"
    ) {
      holidayType = "RELIGIOUS";
    } else if (
      normalizedType === "NATIONAL"
    ) {
      holidayType = "NATIONAL";
    } else if (
      normalizedType === "ENTREPRISE" ||
      normalizedType === "INTERNE_ENTREPRISE"
    ) {
      holidayType = "INTERNE_ENTREPRISE";
    } else {
      holidayType = "NATIONAL";
    }

    const active =
      holiday.is_active !== undefined
        ? Boolean(holiday.is_active)
        : holiday.status === "ACTIVE";

    setFormData({
      name,
      date,
      duration_days: duration,
      holiday_type: holidayType,
      payment_status:
        holiday.payment_status ||
        holiday.details?.payment_status ||
        "PAID",

      is_active: active,
    });

    setError("");
  }, [holiday]);

  // ============================================================
  // MODIFIER UN CHAMP
  // ============================================================
  const handleChange = (e) => {
    const {
      name,
      value,
      type,
      checked,
    } = e.target;

    setFormData((previous) => ({
      ...previous,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));

    if (error) {
      setError("");
    }
  };

  // ============================================================
  // RÉCUPÉRER L'ID RÉEL
  // ============================================================
  const getHolidayId = () => {
    if (!holiday?.id) {
      return null;
    }

    const originalId = String(
      holiday.id
    ).trim();

    console.log(
      "[HolidayEditModal] ID original :",
      originalId
    );

    if (
      originalId.startsWith(
        "holiday-"
      )
    ) {
      const id = originalId.substring(
        "holiday-".length
      );

      if (!id) {
        return null;
      }

      return id;
    }

    return originalId;
  };

  // ============================================================
  // FORMATTER L'ERREUR FASTAPI
  // ============================================================
  const formatBackendError = (err) => {
    const responseData =
      err?.response?.data;

    console.error(
      "[HolidayEditModal] ================================="
    );

    console.error(
      "[HolidayEditModal] Réponse backend complète :",
      responseData
    );

    console.error(
      "[HolidayEditModal] Status HTTP :",
      err?.response?.status
    );

    console.error(
      "[HolidayEditModal] Detail brut :",
      JSON.stringify(
        responseData?.detail,
        null,
        2
      )
    );

    console.error(
      "[HolidayEditModal] ================================="
    );

    // ----------------------------------------------------------
    // FastAPI validation error
    // ----------------------------------------------------------
    if (
      Array.isArray(
        responseData?.detail
      )
    ) {
      return responseData.detail
        .map((item) => {
          if (
            typeof item === "string"
          ) {
            return item;
          }

          const location =
            Array.isArray(item?.loc)
              ? item.loc
              : [];

          const field =
            location.length > 0
              ? location[
                  location.length - 1
                ]
              : null;

          const message =
            item?.msg ||
            item?.message ||
            "Erreur de validation";

          if (field) {
            return `${field} : ${message}`;
          }

          return message;
        })
        .join(" | ");
    }

    // ----------------------------------------------------------
    // detail string
    // ----------------------------------------------------------
    if (
      typeof responseData?.detail ===
      "string"
    ) {
      return responseData.detail;
    }

    // ----------------------------------------------------------
    // message string
    // ----------------------------------------------------------
    if (
      typeof responseData?.message ===
      "string"
    ) {
      return responseData.message;
    }

    // ----------------------------------------------------------
    // Axios
    // ----------------------------------------------------------
    if (
      typeof err?.message ===
      "string"
    ) {
      return err.message;
    }

    return (
      "Impossible de modifier le jour férié."
    );
  };

  // ============================================================
  // VALIDATION
  // ============================================================
  const validateForm = () => {
    const name = String(formData.name || "").trim();

    if (!name) {
      return "Le nom du jour férié est obligatoire.";
    }

    if (!formData.date) {
      return "La date est obligatoire.";
    }

    const duration = Number(formData.duration_days);

    if (!Number.isInteger(duration) || duration < 1) {
      return "La durée doit être un nombre entier supérieur ou égal à 1.";
    }

    const allowedTypes = [
      "NATIONAL",
      "RELIGIOUS",
      "INTERNE_ENTREPRISE",
    ];

    if (!allowedTypes.includes(formData.holiday_type)) {
      return "Le type de jour férié est invalide.";
    }

    if (!["PAID", "UNPAID"].includes(formData.payment_status)) {
      return "Le régime de rémunération est invalide.";
    }

    return null;
  };

  // ============================================================
  // ENREGISTRER
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) {
      return;
    }

    setError("");

    // ----------------------------------------------------------
    // Vérification du jour férié
    // ----------------------------------------------------------
    if (!holiday) {
      setError(
        "Aucun jour férié sélectionné."
      );
      return;
    }

    // ----------------------------------------------------------
    // ID
    // ----------------------------------------------------------
    const holidayId =
      getHolidayId();

    if (!holidayId) {
      setError(
        "Identifiant du jour férié introuvable."
      );

      console.error(
        "[HolidayEditModal] Holiday sans ID :",
        holiday
      );

      return;
    }

    // ----------------------------------------------------------
    // Validation
    // ----------------------------------------------------------
    const validationError =
      validateForm();

    if (validationError) {
      setError(validationError);
      return;
    }

    // ----------------------------------------------------------
    // Préparation des données
    // ----------------------------------------------------------
    const dataToSend = {
      name: String(formData.name).trim(),
      date: formData.date,
      duration_days: Number(formData.duration_days),
      holiday_type: formData.holiday_type,
      payment_status: formData.payment_status,
      is_active: Boolean(formData.is_active),
    };
    console.log(
      "[HolidayEditModal] ================================="
    );

    console.log(
      "[HolidayEditModal] ID original :",
      holiday.id
    );

    console.log(
      "[HolidayEditModal] ID envoyé :",
      holidayId
    );

    console.log(
      "[HolidayEditModal] Données envoyées :",
      dataToSend
    );

    console.log(
      "[HolidayEditModal] JSON envoyé :",
      JSON.stringify(
        dataToSend,
        null,
        2
      )
    );

    console.log(
      "[HolidayEditModal] ================================="
    );

    setLoading(true);

    try {
      // --------------------------------------------------------
      // PUT /holidays/{id}
      // --------------------------------------------------------
      const updatedHoliday =
        await holidayService.updateHoliday(
          holidayId,
          dataToSend
        );

      console.log(
        "[HolidayEditModal] ================================="
      );

      console.log(
        "[HolidayEditModal] MODIFICATION RÉUSSIE"
      );

      console.log(
        "[HolidayEditModal] Réponse API :",
        updatedHoliday
      );

      console.log(
        "[HolidayEditModal] ================================="
      );

      // --------------------------------------------------------
      // Mettre à jour CalendarYearView
      // --------------------------------------------------------
      if (onSaved) {
        onSaved(updatedHoliday);
      }

      // --------------------------------------------------------
      // Fermer la modale
      // --------------------------------------------------------
      onClose();

    } catch (err) {
      console.error(
        "[HolidayEditModal] ================================="
      );

      console.error(
        "[HolidayEditModal] ERREUR MODIFICATION"
      );

      console.error(
        "[HolidayEditModal] Erreur complète :",
        err
      );

      console.error(
        "[HolidayEditModal] Status HTTP :",
        err?.response?.status
      );

      console.error(
        "[HolidayEditModal] Réponse backend :",
        err?.response?.data
      );

      console.error(
        "[HolidayEditModal] Detail 422 :",
        JSON.stringify(
          err?.response?.data?.detail,
          null,
          2
        )
      );

      console.error(
        "[HolidayEditModal] ================================="
      );

      const message =
        formatBackendError(err);

      setError(message);

    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // AUCUN JOUR FÉRIÉ
  // ============================================================
  if (!holiday) {
    return null;
  }

  // ============================================================
  // INTERFACE
  // ============================================================
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor:
          "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent:
          "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "20px",
      }}
      onClick={(e) => {
        if (
          e.target ===
            e.currentTarget &&
          !loading
        ) {
          onClose();
        }
      }}
    >
      <div
        style={{
          backgroundColor:
            "#ffffff",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "500px",
          padding: "24px",
          boxShadow:
            "0 20px 40px rgba(0, 0, 0, 0.2)",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >

        {/* ======================================================
            HEADER
        ====================================================== */}
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "600",
              color: "#111827",
            }}
          >
            Modifier le jour férié
          </h2>

          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            aria-label="Fermer"
            style={{
              border: "none",
              background:
                "transparent",
              fontSize: "28px",
              cursor: loading
                ? "not-allowed"
                : "pointer",
              color: "#6b7280",
              lineHeight: 1,
              padding:
                "0 4px",
            }}
          >
            ×
          </button>
        </div>

        {/* ======================================================
            INFORMATIONS
        ====================================================== */}
        <div
          style={{
            backgroundColor:
              "#f3f4f6",
            borderRadius: "8px",
            padding:
              "10px 12px",
            marginBottom: "18px",
            fontSize: "13px",
            color: "#4b5563",
          }}
        >
          <div>
            <strong>
              ID :
            </strong>{" "}
            {holiday.id}
          </div>

          <div>
            <strong>
              Événement :
            </strong>{" "}
            {holiday.title ||
              holiday.name ||
              "Jour férié"}
          </div>

          <div>
            <strong>
              Date actuelle :
            </strong>{" "}
            {holiday.date ||
              holiday.start ||
              "-"}
          </div>
        </div>

        {/* ======================================================
            ERREUR
        ====================================================== */}
        {error && (
          <div
            style={{
              backgroundColor:
                "#fee2e2",
              color:
                "#b91c1c",
              padding: "12px",
              borderRadius:
                "8px",
              marginBottom:
                "18px",
              fontSize: "14px",
              border:
                "1px solid #fecaca",
              lineHeight:
                "1.5",
            }}
          >
            <strong>
              Erreur :
            </strong>{" "}
            {error}
          </div>
        )}

        {/* ======================================================
            FORMULAIRE
        ====================================================== */}
        <form
          onSubmit={
            handleSubmit
          }
        >

          {/* ====================================================
              NOM
          ==================================================== */}
          <div
            style={{
              marginBottom:
                "18px",
            }}
          >
            <label
              htmlFor="holiday-name"
              style={{
                display:
                  "block",
                marginBottom:
                  "7px",
                fontWeight:
                  "600",
                color:
                  "#374151",
              }}
            >
              Nom du jour férié *
            </label>

            <input
              id="holiday-name"
              type="text"
              name="name"
              value={
                formData.name
              }
              onChange={
                handleChange
              }
              required
              disabled={loading}
              placeholder="Ex : Fête de l'Indépendance"
              style={{
                width: "100%",
                padding:
                  "10px 12px",
                border:
                  "1px solid #d1d5db",
                borderRadius:
                  "7px",
                boxSizing:
                  "border-box",
                fontSize:
                  "14px",
                outline:
                  "none",
              }}
            />
          </div>

          {/* ====================================================
              DATE
          ==================================================== */}
          <div
            style={{
              marginBottom:
                "18px",
            }}
          >
            <label
              htmlFor="holiday-date"
              style={{
                display:
                  "block",
                marginBottom:
                  "7px",
                fontWeight:
                  "600",
                color:
                  "#374151",
              }}
            >
              Date *
            </label>

            <input
              id="holiday-date"
              type="date"
              name="date"
              value={
                formData.date
              }
              onChange={
                handleChange
              }
              required
              disabled={loading}
              style={{
                width: "100%",
                padding:
                  "10px 12px",
                border:
                  "1px solid #d1d5db",
                borderRadius:
                  "7px",
                boxSizing:
                  "border-box",
                fontSize:
                  "14px",
                outline:
                  "none",
              }}
            />
          </div>

          {/* ====================================================
              DURÉE
          ==================================================== */}
          <div
            style={{
              marginBottom:
                "18px",
            }}
          >
            <label
              htmlFor="holiday-duration"
              style={{
                display:
                  "block",
                marginBottom:
                  "7px",
                fontWeight:
                  "600",
                color:
                  "#374151",
              }}
            >
              Durée (jours) *
            </label>

            <input
              id="holiday-duration"
              type="number"
              name="duration_days"
              min="1"
              step="1"
              value={
                formData.duration_days
              }
              onChange={
                handleChange
              }
              required
              disabled={loading}
              style={{
                width: "100%",
                padding:
                  "10px 12px",
                border:
                  "1px solid #d1d5db",
                borderRadius:
                  "7px",
                boxSizing:
                  "border-box",
                fontSize:
                  "14px",
                outline:
                  "none",
              }}
            />
          </div>

          {/* ====================================================
              TYPE
          ==================================================== */}
          <div
            style={{
              marginBottom:
                "18px",
            }}
          >
            <label
              htmlFor="holiday-type"
              style={{
                display:
                  "block",
                marginBottom:
                  "7px",
                fontWeight:
                  "600",
                color:
                  "#374151",
              }}
            >
              Type *
            </label>

            <select
              id="holiday-type"
              name="holiday_type"
              value={
                formData.holiday_type
              }
              onChange={
                handleChange
              }
              disabled={loading}
              style={{
                width: "100%",
                padding:
                  "10px 12px",
                border:
                  "1px solid #d1d5db",
                borderRadius:
                  "7px",
                boxSizing:
                  "border-box",
                fontSize:
                  "14px",
                backgroundColor:
                  "#ffffff",
                outline:
                  "none",
              }}
            >
              <option value="NATIONAL">
                National
              </option>

              <option value="RELIGIOUS">
                Religieux
              </option>

              <option value="INTERNE_ENTREPRISE">
                Interne entreprise
              </option>
            </select>
          </div>

          {/* ====================================================
              RÉMUNÉRATION : CHÔMÉ PAYÉ / NON PAYÉ
          ==================================================== */}
          <div
            style={{
              marginBottom: "20px",
            }}
          >
            <label
              style={{
                display: "block",
                marginBottom: "10px",
                fontWeight: "600",
                color: "#374151",
              }}
            >
              Régime de rémunération *
            </label>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "24px",
                flexWrap: "wrap",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                <input
                  type="radio"
                  name="payment_status"
                  value="PAID"
                  checked={formData.payment_status === "PAID"}
                  onChange={handleChange}
                  disabled={loading}
                />
                <span style={{ color: "#166534", fontWeight: "500" }}>
                  Chômé payé
                </span>
              </label>

              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                <input
                  type="radio"
                  name="payment_status"
                  value="UNPAID"
                  checked={formData.payment_status === "UNPAID"}
                  onChange={handleChange}
                  disabled={loading}
                />
                <span style={{ color: "#991b1b", fontWeight: "500" }}>
                  Chômé non payé
                </span>
              </label>
            </div>

            <small
              style={{
                display: "block",
                marginTop: "8px",
                color: "#64748b",
              }}
            >
              Sélectionnez le régime applicable au jour férié.
            </small>
          </div>

          {/* ====================================================
              ACTIF
          ==================================================== */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "25px",
            }}
          >
            <input
              id="holiday-active"
              type="checkbox"
              name="is_active"
              checked={Boolean(formData.is_active)}
              onChange={handleChange}
              disabled={loading}
            />

            <label
              htmlFor="holiday-active"
              style={{
                color: "#374151",
                fontSize: "14px",
                cursor: loading ? "default" : "pointer",
              }}
            >
              Jour férié actif
            </label>
          </div>

          {/* ====================================================
              BOUTONS
          ==================================================== */}
          <div
            style={{
              display:
                "flex",
              justifyContent:
                "flex-end",
              gap: "10px",
            }}
          >

            {/* ANNULER */}
            <button
              type="button"
              onClick={
                onClose
              }
              disabled={loading}
              style={{
                padding:
                  "10px 18px",
                border:
                  "1px solid #d1d5db",
                backgroundColor:
                  "#ffffff",
                color:
                  "#374151",
                borderRadius:
                  "7px",
                cursor:
                  loading
                    ? "not-allowed"
                    : "pointer",
                fontSize:
                  "14px",
              }}
            >
              Annuler
            </button>

            {/* ENREGISTRER */}
            <button
              type="submit"
              disabled={loading}
              style={{
                padding:
                  "10px 18px",
                border: "none",
                backgroundColor:
                  loading
                    ? "#93c5fd"
                    : "#2563eb",
                color:
                  "#ffffff",
                borderRadius:
                  "7px",
                cursor:
                  loading
                    ? "not-allowed"
                    : "pointer",
                fontSize:
                  "14px",
                fontWeight:
                  "500",
              }}
            >
              {loading
                ? "Enregistrement..."
                : "Enregistrer"}
            </button>

          </div>
        </form>
      </div>
    </div>
  );
};

export default HolidayEditModal;